(() => {
  const initialize = (element) => {
    if (!element || element.dataset.rspStickyInitialized === 'true') return;

    const sourceButton = document.getElementById(element.dataset.sourceButton);
    const stickyButton = element.querySelector('[data-sticky-submit]');
    if (!sourceButton || !stickyButton) return;

    element.dataset.rspStickyInitialized = 'true';
    const sourceFormId = sourceButton.id.replace('ProductSubmitButton-', '');
    const sourceVariantInput = document.getElementById(`product-form-${sourceFormId}`)?.querySelector('.product-variant-id');
    const stickyVariantInput = element.querySelector('.rsp-sticky-variant-id');

    const updateButtonState = () => {
      const unavailable = sourceButton.disabled || sourceButton.getAttribute('aria-disabled') === 'true';
      stickyButton.disabled = unavailable;
      const sourceLabel = sourceButton.querySelector('span')?.textContent?.trim();
      const stickyLabel = stickyButton.querySelector('span');
      if (sourceLabel && stickyLabel) stickyLabel.textContent = sourceLabel;
      if (sourceVariantInput && stickyVariantInput) {
        stickyVariantInput.value = sourceVariantInput.value;
        stickyVariantInput.disabled = sourceVariantInput.disabled;
      }
    };

    const setVisible = (visible) => {
      element.classList.toggle('is-visible', visible);
      element.setAttribute('aria-hidden', visible ? 'false' : 'true');
      document.body.classList.toggle('rsp-sticky-purchase-visible', visible);
    };

    const updateVisibility = () => {
      const sourceRect = sourceButton.getBoundingClientRect();
      const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
      const sourceAboveViewport = sourceRect.bottom < 0;
      const sourceBelowViewportAfterScroll = window.scrollY > 80 && sourceRect.top > viewportHeight;
      setVisible(sourceAboveViewport || sourceBelowViewportAfterScroll);
    };

    let frame = 0;
    const scheduleVisibilityUpdate = () => {
      if (frame) return;
      frame = window.requestAnimationFrame(() => {
        frame = 0;
        updateVisibility();
      });
    };

    const cleanup = () => {
      window.removeEventListener('scroll', scheduleVisibilityUpdate);
      window.removeEventListener('resize', updateVisibility);
      element.purchaseObserver?.disconnect();
      element.buttonObserver?.disconnect();
      if (frame) window.cancelAnimationFrame(frame);
      document.body.classList.remove('rsp-sticky-purchase-visible');
    };

    element.purchaseObserver = 'IntersectionObserver' in window
      ? new IntersectionObserver(scheduleVisibilityUpdate, { threshold: 0.05 })
      : null;
    element.buttonObserver = 'MutationObserver' in window ? new MutationObserver(updateButtonState) : null;
    element.cleanup = cleanup;
    window.addEventListener('scroll', scheduleVisibilityUpdate, { passive: true });
    window.addEventListener('resize', updateVisibility);
    element.purchaseObserver?.observe(sourceButton);
    element.buttonObserver?.observe(sourceButton, { attributes: true, childList: true, subtree: true });
    if (sourceVariantInput) element.buttonObserver?.observe(sourceVariantInput, { attributes: true });
    updateButtonState();
    updateVisibility();
  };

  const boot = () => document.querySelectorAll('roadspec-sticky-purchase').forEach(initialize);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
  document.addEventListener('shopify:section:load', boot);

  if (window.customElements && !customElements.get('roadspec-sticky-purchase')) {
    customElements.define('roadspec-sticky-purchase', class extends HTMLElement {
      connectedCallback() { initialize(this); }
      disconnectedCallback() { this.cleanup?.(); }
    });
  }
})();
